module.exports = __webpack_public_path__ + "static/img/Rectangle 11.04e3661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle 11.png
// module id = 93bk
// module chunks = 1